var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 20,
    viewBox: "0 0 100 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1625 4.61166C99.3619 4.09665 99.1061 3.51746 98.5911 3.31801L90.1985 0.0678114C89.6835 -0.131637 89.1043 0.124179 88.9048 0.639192C88.7054 1.15421 88.9612 1.73339 89.4762 1.93284L96.9363 4.82191L94.0473 12.282C93.8478 12.797 94.1036 13.3762 94.6186 13.5757C95.1337 13.7751 95.7128 13.5193 95.9123 13.0043L99.1625 4.61166ZM0.419922 5.90833L0.000153037 6.81596C20.1732 16.1458 35.6841 19.8151 50.7774 19.079C65.849 18.3439 80.4003 13.2188 98.634 5.16527L98.23 4.25053L97.826 3.33578C79.6314 11.372 65.3634 16.3652 50.68 17.0813C36.0182 17.7964 20.8381 14.2497 0.839691 5.00069L0.419922 5.90833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.6c07fb8a9086d6c84c613c7a600f70ff.svg";
export { ForwardRef as ReactComponent };